import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Text } from '@nike/podium';
import { DetailAccordion, DetailRow, DetailSection } from './EntityOverviewComponents';
import { extractFieldValue, getFieldLabel } from '~/utils/entityDetailUtils';
const CUSTOM_LABELS = {
    styleSportActivity: 'Sport Activity',
    colorDescription: 'Color',
    entryIntoMarket: 'Entry Into Market'
};
const SECTION_CONFIG = [
    {
        id: 'product-info',
        title: 'Product Info',
        fields: ['styleName', 'styleNumber', 'productCode']
    },
    {
        id: 'category',
        title: 'Classification',
        fields: ['category', 'styleSportActivity', 'segment', 'subCategory']
    },
    {
        id: 'size-market',
        title: 'Size & Market',
        fields: ['sizeScale', 'retailSizeRange', 'entryIntoMarket']
    },
    {
        id: 'color',
        title: 'Colors',
        fields: [
            'colorDescription',
            'primaryColor',
            'secondaryColor',
            'tertiaryColor'
        ]
    },
    {
        id: 'status',
        title: 'Status',
        fields: ['status', 'productLifecycle', 'silo']
    }
];
const ALL_SECTIONS_OPEN = SECTION_CONFIG.map((s) => s.id);
function hasFieldsWithValues(product, section) {
    return section.fields.some((field) => {
        const value = extractFieldValue(product, field);
        return value !== undefined && value !== null && value !== '';
    });
}
function FieldRenderer({ product, field }) {
    const value = extractFieldValue(product, field);
    const label = getFieldLabel(field, CUSTOM_LABELS);
    if (!value)
        return null;
    return _jsx(DetailRow, { label: label, value: value });
}
function CategorySection({ product, section }) {
    if (!hasFieldsWithValues(product, section)) {
        return null;
    }
    return (_jsx(DetailSection, { value: section.id, title: section.title, children: section.fields.map((field) => (_jsx(FieldRenderer, { product: product, field: field }, field))) }));
}
function ProductOverviewContent({ product }) {
    return (_jsxs(Stack, { gap: "l", className: "w-full", children: [_jsx(Box, { className: "w-full", children: _jsx(Text, { font: "title-3", children: product.styleName }) }), _jsx(DetailAccordion, { defaultOpen: ALL_SECTIONS_OPEN, children: SECTION_CONFIG.map((section) => (_jsx(CategorySection, { product: product, section: section }, section.id))) })] }));
}
export default ProductOverviewContent;
